// Copyright (c) 2016 Deere & Company

import ServiceIntervalTypes, {getDefaultState} from '../state/service-interval-types';
import actions from '../../actions-list';

const updateServiceIntervalTypes = (state, action) =>
    ServiceIntervalTypes.update(state, {
        $set: action.data
    });

export default (state = getDefaultState(), action) => {

    const actionTypes = {
        [actions.UPDATE_MAINTENANCE_PLAN_SERVICE_INTERVAL_TYPES_SUCCESS]: updateServiceIntervalTypes
    };

    const reducer = actionTypes[action.type];

    return reducer ?
        reducer(state, action) :
        state;

};



// WEBPACK FOOTER //
// ./src/reports/maintenance-plan/reducers/service-interval-types.js